const routes = [
  {
    path: '/change-password',
    name: 'ChangePassword',
    meta: { layout: 'default', menu: 'change-password', requiresAuth: true },
    component: () => import('@/pages/changePassword/ChangePasswordView.vue')
  }
]

export default routes
